import Axios from 'axios';
import { getEndpointURL } from './config';
Axios.defaults.withCredentials = true;

const endpointURL = getEndpointURL();
const headers = { 'Content-Type': 'application/json; charset=utf-8' };

const GetAuthUrl = async function (name) {
    return Axios({
        method: 'POST',
        headers,
        data: { name },
        url: `${endpointURL}/api/connection/get-auth-url`
    })
}

const GetToken = async function (providerID) {
    return Axios({
        method: 'POST',
        headers,
        data: { providerID },
        url: `${endpointURL}/api/connection/get-token`
    })
}

const SaveToken = async function (code, name, providerID) {
    return Axios({
        method: 'POST',
        headers,
        data: { code, name, providerID },
        url: `${endpointURL}/api/connection/save-token`
    })
}

const GetConnection = async (searchConnection, rowsPerPage, page) => {
    return Axios({
        method: 'POST',
        headers,
        data: { searchConnection, rowsPerPage, page },
        url: `${endpointURL}/api/connection/get-connection`
    })
}

const DeleteConnection = async (providerID) => {
    return Axios({
        method: 'POST',
        headers,
        data: { providerID },
        url: `${endpointURL}/api/connection/delete-connection`
    })
}


export {
    GetAuthUrl,
    GetToken,
    SaveToken,
    GetConnection,
    DeleteConnection,
};
